import styled from '@emotion/styled';
import { InnerContent, InnerTitle, TextWrapper } from '..';
import { Table, Td, THead } from './TableComponents';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PCCPCriterion = () => (
  <Container>
    <TextWrapper gap="5px">
      <InnerTitle>합격 기준</InnerTitle>
      <TextWrapper>
        <InnerContent>1,000점 만점 기준에서 400점 이상 획득하면 합격입니다.</InnerContent>
        <InnerContent>점수에 따라 인증 등급(Lv)이 부여되며, 기준은 아래와 같습니다.</InnerContent>
      </TextWrapper>
    </TextWrapper>
    <Table>
      <THead>
        <tr>
          <Td width="12%">등급</Td>
          <Td width="12%">획득점수</Td>
          <Td>등급별 역량</Td>
        </tr>
      </THead>
      <tbody>
        <tr>
          <Td>LV.1</Td>
          <Td>400 ~ 499점</Td>
          <Td alignLeft>프로그래밍 언어로 초급 수준의 문제를 해결할 수 있습니다. 명시된 절차를 보고 제한적인 과제를 해결할 수 있습니다.</Td>
        </tr>
        <tr>
          <Td>LV.2</Td>
          <Td>500 ~ 599점</Td>
          <Td alignLeft>프로그래밍 언어로 중급 수준의 문제를 해결할 수 있습니다. 스스로 알고리즘을 설계하여 일반적인 과제를 해결할 수 있습니다.</Td>
        </tr>
        <tr>
          <Td>LV.3</Td>
          <Td>600 ~ 749점</Td>
          <Td alignLeft>프로그래밍 언어로 중상 수준의 문제를 정확히 해결할 수 있습니다. 적절한 알고리즘을 설계하여 다양한 과제를 해결할 수 있습니다.</Td>
        </tr>
        <tr>
          <Td>LV.4</Td>
          <Td>750 ~ 899점</Td>
          <Td alignLeft>프로그래밍 언어로 상급 수준의 문제를 해결할 수 있습니다. 효율적인 알고리즘을 설계하여 복잡한 과제를 해결할 수 있습니다.</Td>
        </tr>
        <tr>
          <Td>LV.5</Td>
          <Td>900 ~ 1,000점</Td>
          <Td alignLeft>프로그래밍 언어로 상급 수준의 문제를 최적의 방법으로 해결할 수 있습니다. 최선의 알고리즘을 설계하여 고난도 과제를 주도적으로 해결할 수 있습니다.</Td>
        </tr>
      </tbody>
    </Table>
  </Container>
);

export const PCCECriterion = () => (
  <Container>
    <TextWrapper gap="5px">
      <InnerTitle>합격 기준</InnerTitle>
      <TextWrapper>
        <InnerContent>1,000점 만점 기준에서 400점 이상 획득하면 합격입니다.</InnerContent>
        <InnerContent>점수에 따라 인증 등급(Lv)이 부여되며, 기준은 아래와 같습니다.</InnerContent>
      </TextWrapper>
    </TextWrapper>
    <Table>
      <THead>
        <tr>
          <Td width="12%">등급</Td>
          <Td width="12%">획득점수</Td>
          <Td>등급별 역량</Td>
        </tr>
      </THead>
      <tbody>
        <tr>
          <Td>LV.1</Td>
          <Td>400 ~ 599점</Td>
          <Td alignLeft>프로그래밍 개념과 기본적인 문법 지식을 가지고 간단한 문제 해결 및 프로그램을 작성하는 능력이 있습니다.</Td>
        </tr>
        <tr>
          <Td>LV.2</Td>
          <Td>600 ~ 749점</Td>
          <Td alignLeft>프로그래밍 기본 지식을 가지고 복잡하지 않은 프로그램 설계·구현, 디버깅 문제를 해결할 수 있는 능력이 있습니다.</Td>
        </tr>
        <tr>
          <Td>LV.3</Td>
          <Td>750 ~ 899점</Td>
          <Td alignLeft>프로그래밍 중급 지식을 가지고 간단한 프로그램을 요구사항에 맞게 설계·구현, 디버깅, 수정 등 테스트 케이스를 설계할 수 있는 능력이 있습니다.</Td>
        </tr>
        <tr>
          <Td>LV.4</Td>
          <Td>900 ~ 1000점</Td>
          <Td alignLeft>프로그래밍 중급 지식을 가지고 프로그램을 요구사항에 맞게 설계·구현할 수 있는 능력이 있습니다.</Td>
        </tr>
      </tbody>
    </Table>
  </Container>
);

export const PCSQLCriterion = () => (
  <Container>
    <TextWrapper gap="5px">
      <InnerTitle>합격 기준</InnerTitle>
      <TextWrapper>
        <InnerContent>1,000점 만점 기준에서 200점 이상 획득하면 합격입니다.</InnerContent>
        <InnerContent>점수에 따라 인증 등급(Lv)이 부여되며, 기준은 아래와 같습니다.</InnerContent>
      </TextWrapper>
    </TextWrapper>
    <Table>
      <THead>
        <tr>
          <Td width="12%">등급</Td>
          <Td width="12%">획득점수</Td>
          <Td>등급별 역량</Td>
        </tr>
      </THead>
      <tbody>
        <tr>
          <Td>LV.1</Td>
          <Td>200 ~ 449점</Td>
          <Td alignLeft>SQL 지식을 활용하여, 초급 수준의 문제를 해결할 수 있습니다. 데이터 추출을 위한 매우 단순한 데이터베이스 쿼리를 작성할 수 있습니다.</Td>
        </tr>
        <tr>
          <Td>LV.2</Td>
          <Td>450 ~ 699점</Td>
          <Td alignLeft>SQL 지식을 활용하여, 중급 수준의 문제를 해결할 수 있습니다. 데이터 추출과 간단한 집계 등 기본적인 쿼리를 작성할 수 있습니다.</Td>
        </tr>
        <tr>
          <Td>LV.3</Td>
          <Td>700 ~ 899점</Td>
          <Td alignLeft>SQL 지식을 활용하여, 중상 수준의 문제를 해결할 수 있습니다. 데이터 추출 및 가공, 다양한 요구사항을 처리하는 쿼리를 작성할 수 있습니다.</Td>
        </tr>
        <tr>
          <Td>LV.4</Td>
          <Td>900 ~ 1000점</Td>
          <Td alignLeft>SQL 지식을 활용하여, 상급 수준의 문제를 해결할 수 있습니다. 쿼리 언어의 다양한 문법과 함수 사용에 막힘이 없고, 복잡한 요구사항에 대해 창의적이고 효율적인 쿼리를 작성할 수 있습니다.</Td>
        </tr>
      </tbody>
    </Table>
  </Container>
);
